import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Projects from '../components/Projects';
import WhyChooseUs from '../components/WhyChooseUs';
import About from '../components/About';
import Process from '../components/Process';
import Contact from '../components/Contact';
import CTA from '../components/CTA';

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Hero theme="light" />
      <Services theme="dark" />
      <Projects />
      <WhyChooseUs />
      <About />
      <Process theme="light" />
      <CTA theme="light" />
      <Contact />
    </>
  );
};

export default Home;
